<template>
  <div class="row mb5">
    <div class="col-md-12">
      <form @onsubmit.prevent action>
        <div
          v-for="(field, index) in fields"
          v-bind:key="index"
          class="row"
          style="margin-bottom: 10px;"
        >
          <div class="col-md-4">
            <label :for="field.name" class="form-control-label">{{field.label}}</label>
          </div>
          <div class="col col-md-3">
            <input
              :type="field.type"
              v-model="formData[field.name]"
              :id="field.name"
              placeholder="Enter Value"
              class="form-control"
            >
            <!-- <small v-if="errors[field.name].value" class="form-text text-danger">{{errors[field.name].value}}</small> -->
          </div>
          <div class="col col-md-3">
            <input
              :type="field.type"
              v-model="formData[field.name+'_source']"
              :id="field.name"
              placeholder="Enter Source"
              class="form-control"
            >
            <!-- <small v-if="errors[field.name].source" class="form-text text-danger">{{errors[field.name].source}}</small> -->
          </div>
          <div class="col col-md-2">
            <input
              :type="field.type"
              v-model="formData[field.name+'_date']"
              :id="field.name"
              placeholder="Enter Date"
              class="form-control"
            >
            <!-- <small v-if="errors[field.name].Date" class="form-text text-danger">{{errors[field.name].Date}}</small> -->
          </div>
        </div>
        <div class="form-group pull-right">
          <!-- <submitButton @click.prevent="submitGlobalForm" type="submit" class="btn btn-info">Submit</submitButton> -->
          <button @click="save" type="button" class="btn btn-primary">Save & Run as per daily cron</button>
          <button @click="update" type="button" class="btn btn-primary">Save & Run cron immediately</button>
        </div>
      </form>
    </div>
    <PinCheck :show.sync="show" ref="smallModal" v-bind:small="true" @submitForm="submitForm" :cancelClass="'btn btn-secondary'"></PinCheck>
  </div>
</template>
<script>
import http from "@/lib/http";
import { formCommonMixins } from "../../assets/mixins/formcommon.js";
import PinCheck from "@/components/PinCheck.vue";
export default {
  components: {PinCheck},
  mixins: [formCommonMixins],
  created() {
    this.getGlobalFormData();
  },
  data() {
    return {
      show: false,
      pin: "",
      curDate: new Date(),
      globalData: {
        current_long_term_treasury_yield: { value: "", source: "", Date: "" },
        projected_earnings_growth_of_sensex_the_current_year: {
          value: "",
          source: "",
          Date: ""
        },
        projected_earnings_growth_of_sensex_of_the_year_following_the_current_year: {
          value: "",
          source: "",
          Date: ""
        },
        inflation: { value: "", source: "", Date: "" },
        discount_rate_or_bank_rate_latest: { value: "", source: "", Date: "" },
        discount_rate_or_bank_rate_a_quarter_or_two_quarters_back: {
          value: "",
          source: "",
          Date: ""
        },
        reserve_requirements_a_quarter_or_two_quarters_back: {
          value: "",
          source: "",
          Date: ""
        },
        reserve_requirements_latest: {
          value: "",
          source: "",
          Date: ""
        },
        repo_rate_latest: { value: "", source: "", Date: "" },
        repo_rate_a_quarter_or_two_quarters_back: {
          value: "",
          source: "",
          Date: ""
        },
        gdp_growth_latest: { value: "", source: "", Date: "" },
        gdp_growth_one_year_back: { value: "", source: "", Date: "" },
        installment_debt_mortgages_and_personal_loans_latest: {
          value: "",
          source: "",
          Date: ""
        },
        installment_debt_mortgages_and_personal_loans_one_year_back: {
          value: "",
          source: "",
          Date: ""
        },
        prime_rate_or_base_rate_set_by_sbi_latest: {
          value: "",
          source: "",
          Date: ""
        },
        prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back: {
          value: "",
          source: "",
          Date: ""
        },
        prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back: {
          value: "",
          source: "",
          Date: ""
        },
        tax_rate: { value: "", source: "", Date: "" },
        corporate_long_term_interest_rate: { value: "", source: "", Date: "" },
        personal_loans_latest: { value: "", source: "", Date: "" },
        mortgages_latest: { value: "", source: "", Date: "" },
        personal_loans_one_year_back: { value: "", source: "", Date: "" },
        mortgages_one_year_back: { value: "", source: "", Date: "" }
      },
      fields: [
        {
          label: "Current Long-term treasury yield (%)",
          name: "current_long_term_treasury_yield",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "current_long_term_treasury_yield_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "current_long_term_treasury_yield_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Projected earnings growth of Sensex the current year",
          name: "projected_earnings_growth_of_sensex_the_current_year",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "projected_earnings_growth_of_sensex_the_current_year_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "projected_earnings_growth_of_sensex_the_current_year_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label:
            "Projected earnings growth of Sensex of the year following the current year",
          name:
            "projected_earnings_growth_of_sensex_of_the_year_following_the_current_year",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "projected_earnings_growth_of_sensex_of_the_year_following_the_current_year_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "projected_earnings_growth_of_sensex_of_the_year_following_the_current_year_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Inflation",
          name: "inflation",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "inflation_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "inflation_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Discount rate or bank rate (latest)",
          name: "discount_rate_or_bank_rate_latest",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "discount_rate_or_bank_rate_latest_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "discount_rate_or_bank_rate_latest_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Discount rate or bank rate (a quarter or two quarters back)",
          name: "discount_rate_or_bank_rate_a_quarter_or_two_quarters_back",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "discount_rate_or_bank_rate_a_quarter_or_two_quarters_back_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "discount_rate_or_bank_rate_a_quarter_or_two_quarters_back_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Reserve Requirements (a quarter or two quarters back)",
          name: "reserve_requirements_a_quarter_or_two_quarters_back",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "reserve_requirements_a_quarter_or_two_quarters_back_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "reserve_requirements_a_quarter_or_two_quarters_back_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Reserve Requirements (Latest)",
          name: "reserve_requirements_latest",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "reserve_requirements_latest_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "reserve_requirements_latest_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Repo rate (latest)",
          name: "repo_rate_latest",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "repo_rate_latest_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "repo_rate_latest_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Repo rate (a quarter or two quarters back)",
          name: "repo_rate_a_quarter_or_two_quarters_back",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "repo_rate_a_quarter_or_two_quarters_back_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "repo_rate_a_quarter_or_two_quarters_back_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "GDP growth (latest)",
          name: "gdp_growth_latest",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "gdp_growth_latest_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "gdp_growth_latest_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "GDP growth (one year back)",
          name: "gdp_growth_one_year_back",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "gdp_growth_one_year_back_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "gdp_growth_one_year_back_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label:
            "Installment debt (mortgages and personal loans) (latest)-Rs. Lakh Crore",
          name: "installment_debt_mortgages_and_personal_loans_latest",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "installment_debt_mortgages_and_personal_loans_latest_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "installment_debt_mortgages_and_personal_loans_latest_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Mortgages (Latest)",
          name: "mortgages_latest",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "mortgages_latest_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "mortgages_latest_date",
              type: "date",
              value: ""
            }
          ]
        },
        {
          label: "Personal Loan (Latest)",
          name: "personal_loan_latest",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "personal_loans_latest_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "personal_loans_latest_date",
              type: "date",
              value: ""
            }
          ]
        },
        {
          label:
            "Installment debt (mortgages and personal loans) (one year back)-Rs. Lakh Crore",
          name: "installment_debt_mortgages_and_personal_loans_one_year_back",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "installment_debt_mortgages_and_personal_loans_one_year_back_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "installment_debt_mortgages_and_personal_loans_one_year_back_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Mortgages (1 Year Back)",
          name: "mortgages_one_year_back",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "mortgages_one_year_back_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "mortgages_one_year_back_date",
              type: "date",
              value: ""
            }
          ]
        },
        {
          label: "Personal Loan (1 Year Back)",
          name: "personal_loans_one_year_back",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "personal_loans_one_year_back_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "personal_loans_one_year_back_date",
              type: "date",
              value: ""
            }
          ]
        },
        {
          label: "Prime rate or Base rate (set by SBI)-latest",
          name: "prime_rate_or_base_rate_set_by_sbi_latest",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "prime_rate_or_base_rate_set_by_sbi_latest_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "prime_rate_or_base_rate_set_by_sbi_latest_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label:
            "Prime rate or Base rate (set by SBI)-a quarter or two quarters back",
          name:
            "prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Prime rate or Base rate (set by SBI)-3 or 4 quarters back",
          name: "prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Tax Rate",
          name: "tax_rate",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "tax_rate_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "tax_rate_date",
              type: "text",
              value: ""
            }
          ]
        },
        {
          label: "Corporate long-term interest rate",
          name: "corporate_long_term_interest_rate",
          type: "text",
          value: "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "corporate_long_term_interest_rate_source",
              type: "text",
              value: ""
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "corporate_long_term_interest_rate_date",
              type: "text",
              value: ""
            }
          ]
        }
      ],
      formData: {},
      errors: [],
      defaultSrc: "RBI"
    };
  },
  methods: {
    setData() {
      this.fields = [
        {
          label: "Current Long-term treasury yield (%)",
          name: "current_long_term_treasury_yield",
          type: "text",
          value: this.globalData.current_long_term_treasury_yield
            ? this.globalData.current_long_term_treasury_yield.value
            : 0.072,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "current_long_term_treasury_yield_source",
              type: "text",
              value: this.globalData.current_long_term_treasury_yield
                ? this.globalData.current_long_term_treasury_yield.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "current_long_term_treasury_yield_date",
              type: "date",
              value: this.globalData.current_long_term_treasury_yield
                ? this.globalData.current_long_term_treasury_yield.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Projected earnings growth of Sensex the current year",
          name: "projected_earnings_growth_of_sensex_the_current_year",
          type: "text",
          value: this.globalData
            .projected_earnings_growth_of_sensex_the_current_year
            ? this.globalData
                .projected_earnings_growth_of_sensex_the_current_year.value
            : 0.1,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "projected_earnings_growth_of_sensex_the_current_year_source",
              type: "text",
              value: this.globalData
                .projected_earnings_growth_of_sensex_the_current_year
                ? this.globalData
                    .projected_earnings_growth_of_sensex_the_current_year.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "projected_earnings_growth_of_sensex_the_current_year_date",
              type: "date",
              value: this.globalData
                .projected_earnings_growth_of_sensex_the_current_year
                ? this.globalData
                    .projected_earnings_growth_of_sensex_the_current_year.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label:
            "Projected earnings growth of Sensex of the year following the current year",
          name:
            "projected_earnings_growth_of_sensex_of_the_year_following_the_current_year",
          type: "text",
          value: this.globalData
            .projected_earnings_growth_of_sensex_of_the_year_following_the_current_year
            ? this.globalData
                .projected_earnings_growth_of_sensex_of_the_year_following_the_current_year
                .value
            : 0.1,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "projected_earnings_growth_of_sensex_of_the_year_following_the_current_year_source",
              type: "text",
              value: this.globalData
                .projected_earnings_growth_of_sensex_of_the_year_following_the_current_year
                ? this.globalData
                    .projected_earnings_growth_of_sensex_of_the_year_following_the_current_year
                    .source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "projected_earnings_growth_of_sensex_of_the_year_following_the_current_year_date",
              type: "date",
              value: this.globalData
                .projected_earnings_growth_of_sensex_of_the_year_following_the_current_year
                ? this.globalData
                    .projected_earnings_growth_of_sensex_of_the_year_following_the_current_year
                    .Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Inflation",
          name: "inflation",
          type: "text",
          value: this.globalData.inflation
            ? this.globalData.inflation.value
            : 0.036,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "inflation_source",
              type: "text",
              value: this.globalData.inflation
                ? this.globalData.inflation.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "inflation_date",
              type: "date",
              value: this.globalData.inflation
                ? this.globalData.inflation.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Discount rate or bank rate (latest)",
          name: "discount_rate_or_bank_rate_latest",
          type: "text",
          value: this.globalData.discount_rate_or_bank_rate_latest
            ? this.globalData.discount_rate_or_bank_rate_latest.value
            : 0.0625,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "discount_rate_or_bank_rate_latest_source",
              type: "text",
              value: this.globalData.discount_rate_or_bank_rate_latest
                ? this.globalData.discount_rate_or_bank_rate_latest.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "discount_rate_or_bank_rate_latest_date",
              type: "date",
              value: this.globalData.discount_rate_or_bank_rate_latest
                ? this.globalData.discount_rate_or_bank_rate_latest.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Discount rate or bank rate (a quarter or two quarters back)",
          name: "discount_rate_or_bank_rate_a_quarter_or_two_quarters_back",
          type: "text",
          value: this.globalData
            .discount_rate_or_bank_rate_a_quarter_or_two_quarters_back
            ? this.globalData
                .discount_rate_or_bank_rate_a_quarter_or_two_quarters_back.value
            : 0.0625,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "discount_rate_or_bank_rate_a_quarter_or_two_quarters_back_source",
              type: "text",
              value: this.globalData
                .discount_rate_or_bank_rate_a_quarter_or_two_quarters_back
                ? this.globalData
                    .discount_rate_or_bank_rate_a_quarter_or_two_quarters_back
                    .source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "discount_rate_or_bank_rate_a_quarter_or_two_quarters_back_date",
              type: "date",
              value: this.globalData
                .discount_rate_or_bank_rate_a_quarter_or_two_quarters_back
                ? this.globalData
                    .discount_rate_or_bank_rate_a_quarter_or_two_quarters_back
                    .Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Reserve Requirements (Latest)",
          name: "reserve_requirements_latest",
          type: "text",
          value: this.globalData.reserve_requirements_latest
            ? this.globalData.reserve_requirements_latest.value
            : 0.04,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "reserve_requirements_latest_source",
              type: "text",
              value: this.globalData.reserve_requirements_latest
                ? this.globalData.reserve_requirements_latest.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "reserve_requirements_latest_date",
              type: "date",
              value: this.globalData.reserve_requirements_latest
                ? this.globalData.reserve_requirements_latest.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Reserve Requirements (a quarter or two quarters back)",
          name: "reserve_requirements_a_quarter_or_two_quarters_back",
          type: "text",
          value: this.globalData
            .reserve_requirements_a_quarter_or_two_quarters_back
            ? this.globalData
                .reserve_requirements_a_quarter_or_two_quarters_back.value
            : 0.04,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "reserve_requirements_a_quarter_or_two_quarters_back_source",
              type: "text",
              value: this.globalData
                .reserve_requirements_a_quarter_or_two_quarters_back
                ? this.globalData
                    .reserve_requirements_a_quarter_or_two_quarters_back.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "reserve_requirements_a_quarter_or_two_quarters_back_date",
              type: "date",
              value: this.globalData
                .reserve_requirements_a_quarter_or_two_quarters_back
                ? this.globalData
                    .reserve_requirements_a_quarter_or_two_quarters_back.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Repo rate (latest)",
          name: "repo_rate_latest",
          type: "text",
          value: this.globalData.repo_rate_latest
            ? this.globalData.repo_rate_latest.value
            : 0.06,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "repo_rate_latest_source",
              type: "text",
              value: this.globalData.repo_rate_latest
                ? this.globalData.repo_rate_latest.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "repo_rate_latest_date",
              type: "date",
              value: this.globalData.repo_rate_latest
                ? this.globalData.repo_rate_latest.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Repo rate (a quarter or two quarters back)",
          name: "repo_rate_a_quarter_or_two_quarters_back",
          type: "text",
          value: this.globalData.repo_rate_a_quarter_or_two_quarters_back
            ? this.globalData.repo_rate_a_quarter_or_two_quarters_back.value
            : 0.06,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "repo_rate_a_quarter_or_two_quarters_back_source",
              type: "text",
              value: this.globalData.repo_rate_a_quarter_or_two_quarters_back
                ? this.globalData.repo_rate_a_quarter_or_two_quarters_back
                    .source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "repo_rate_a_quarter_or_two_quarters_back_date",
              type: "date",
              value: this.globalData.repo_rate_a_quarter_or_two_quarters_back
                ? this.globalData.repo_rate_a_quarter_or_two_quarters_back.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "GDP growth (latest)",
          name: "gdp_growth_latest",
          type: "text",
          value: this.globalData.gdp_growth_latest
            ? this.globalData.gdp_growth_latest.value
            : 0.065,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "gdp_growth_latest_source",
              type: "text",
              value: this.globalData.gdp_growth_latest
                ? this.globalData.gdp_growth_latest.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "gdp_growth_latest_date",
              type: "date",
              value: this.globalData.gdp_growth_latest
                ? this.globalData.gdp_growth_latest.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "GDP growth (one year back)",
          name: "gdp_growth_one_year_back",
          type: "text",
          value: this.globalData.gdp_growth_one_year_back
            ? this.globalData.gdp_growth_one_year_back.value
            : 0.0710,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "gdp_growth_one_year_back_source",
              type: "text",
              value: this.globalData.gdp_growth_one_year_back
                ? this.globalData.gdp_growth_one_year_back.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "gdp_growth_one_year_back_date",
              type: "date",
              value: this.globalData.gdp_growth_one_year_back
                ? this.globalData.gdp_growth_one_year_back.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label:
            "Installment debt (mortgages and personal loans) (latest)-Rs. Lakh Crore",
          name: "installment_debt_mortgages_and_personal_loans_latest",
          type: "text",
          value: this.globalData
            .installment_debt_mortgages_and_personal_loans_latest
            ? this.globalData
                .installment_debt_mortgages_and_personal_loans_latest.value
            : "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "installment_debt_mortgages_and_personal_loans_latest_source",
              type: "text",
              value: this.globalData
                .installment_debt_mortgages_and_personal_loans_latest
                ? this.globalData
                    .installment_debt_mortgages_and_personal_loans_latest.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "installment_debt_mortgages_and_personal_loans_latest_date",
              type: "date",
              value: this.globalData
                .installment_debt_mortgages_and_personal_loans_latest
                ? this.globalData
                    .installment_debt_mortgages_and_personal_loans_latest.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Mortgages (Latest)",
          name: "mortgages_latest",
          type: "text",
          value: this.globalData.mortgages_latest
            ? this.globalData.mortgages_latest.value
            : 10,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "mortgages_latest_source",
              type: "text",
              value: this.globalData.mortgages_latest
                ? this.globalData.mortgages_latest.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "mortgages_latest_date",
              type: "date",
              value: this.globalData.mortgages_latest
                ? this.globalData.mortgages_latest.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Personal Loan (Latest)",
          name: "personal_loans_latest",
          type: "text",
          value: this.globalData.personal_loans_latest
            ? this.globalData.personal_loans_latest.value
            : '',
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "personal_loans_latest_source",
              type: "text",
              value: this.globalData.personal_loans_latest
                ? this.globalData.personal_loans_latest.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "personal_loans_latest_date",
              type: "date",
              value: this.globalData.personal_loans_latest
                ? this.globalData.personal_loans_latest.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label:
            "Installment debt (mortgages and personal loans) (one year back)-Rs. Lakh Crore",
          name: "installment_debt_mortgages_and_personal_loans_one_year_back",
          type: "text",
          value: this.globalData
            .installment_debt_mortgages_and_personal_loans_one_year_back
            ? this.globalData
                .installment_debt_mortgages_and_personal_loans_one_year_back
                .value
            : "",
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "installment_debt_mortgages_and_personal_loans_one_year_back_source",
              type: "text",
              value: this.globalData
                .installment_debt_mortgages_and_personal_loans_one_year_back
                ? this.globalData
                    .installment_debt_mortgages_and_personal_loans_one_year_back
                    .source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "installment_debt_mortgages_and_personal_loans_one_year_back_date",
              type: "date",
              value: this.globalData
                .installment_debt_mortgages_and_personal_loans_one_year_back
                ? this.globalData
                    .installment_debt_mortgages_and_personal_loans_one_year_back
                    .Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Mortgages (1 Year Back)",
          name: "mortgages_one_year_back",
          type: "text",
          value: this.globalData.mortgages_one_year_back
            ? this.globalData.mortgages_one_year_back.value
            : 10,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "mortgages_one_year_back_source",
              type: "text",
              value: this.globalData.mortgages_one_year_back
                ? this.globalData.mortgages_one_year_back.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "mortgages_one_year_back_date",
              type: "date",
              value: this.globalData.mortgages_one_year_back
                ? this.globalData.mortgages_one_year_back.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Personal Loan (1 Year Back)",
          name: "personal_loans_one_year_back",
          type: "text",
          value: this.globalData.personal_loans_one_year_back
            ? this.globalData.personal_loans_one_year_back.value
            : '',
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "personal_loans_one_year_back_source",
              type: "text",
              value: this.globalData.personal_loans_one_year_back
                ? this.globalData.personal_loans_one_year_back.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "personal_loans_one_year_back_date",
              type: "date",
              value: this.globalData.personal_loans_one_year_back
                ? this.globalData.personal_loans_one_year_back.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Prime rate or Base rate (set by SBI)-latest",
          name: "prime_rate_or_base_rate_set_by_sbi_latest",
          type: "text",
          value: this.globalData.prime_rate_or_base_rate_set_by_sbi_latest
            ? this.globalData.prime_rate_or_base_rate_set_by_sbi_latest.value
            : 0.0810,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "prime_rate_or_base_rate_set_by_sbi_latest_source",
              type: "text",
              value: this.globalData.prime_rate_or_base_rate_set_by_sbi_latest
                ? this.globalData.prime_rate_or_base_rate_set_by_sbi_latest
                    .source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "prime_rate_or_base_rate_set_by_sbi_latest_date",
              type: "date",
              value: this.globalData.prime_rate_or_base_rate_set_by_sbi_latest
                ? this.globalData.prime_rate_or_base_rate_set_by_sbi_latest.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label:
            "Prime rate or Base rate (set by SBI)-a quarter or two quarters back",
          name:
            "prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back",
          type: "text",
          value: this.globalData
            .prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back
            ? this.globalData
                .prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back
                .value
            : 0.0815,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back_source",
              type: "text",
              value: this.globalData
                .prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back
                ? this.globalData
                    .prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back
                    .source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back_date",
              type: "date",
              value: this.globalData
                .prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back
                ? this.globalData
                    .prime_rate_or_base_rate_set_by_sbi_a_quarter_or_two_quarters_back
                    .Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Prime rate or Base rate (set by SBI)-3 or 4 quarters back",
          name: "prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back",
          type: "text",
          value: this.globalData
            .prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back
            ? this.globalData
                .prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back.value
            : 0.0930,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name:
                "prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back_source",
              type: "text",
              value: this.globalData
                .prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back
                ? this.globalData
                    .prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back
                    .source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name:
                "prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back_date",
              type: "date",
              value: this.globalData
                .prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back
                ? this.globalData
                    .prime_rate_or_base_rate_set_by_sbi_3_or_4_quarters_back
                    .Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Tax Rate",
          name: "tax_rate",
          type: "text",
          value: this.globalData.tax_rate ? this.globalData.tax_rate.value : 0.33,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "tax_rate_source",
              type: "text",
              value: this.globalData.tax_rate
                ? this.globalData.tax_rate.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "tax_rate_date",
              type: "date",
              value: this.globalData.tax_rate
                ? this.globalData.tax_rate.Date
                : this.getDate(this.curDate)
            }
          ]
        },
        {
          label: "Corporate long-term interest rate",
          name: "corporate_long_term_interest_rate",
          type: "text",
          value: this.globalData.corporate_long_term_interest_rate
            ? this.globalData.corporate_long_term_interest_rate.value
            : 0.1,
          reletedField: [
            {
              label: "source",
              placeholder: "Enter Source",
              name: "corporate_long_term_interest_rate_source",
              type: "text",
              value: this.globalData.corporate_long_term_interest_rate
                ? this.globalData.corporate_long_term_interest_rate.source
                : this.defaultSrc
            },
            {
              label: "date",
              placeholder: "Enter Date",
              name: "corporate_long_term_interest_rate_date",
              type: "date",
              value: this.globalData.corporate_long_term_interest_rate
                ? this.globalData.corporate_long_term_interest_rate.Date
                : this.getDate(this.curDate)
            }
          ]
        }
      ];
      console.log(this.globalData.personal_loans_latest);
      console.log("Set Value ", this.fields);
    },
    cancel(d){
      console.log("Cancel =>", d);
    },
    submitForm(){
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.submitGlobalForm();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    save(){
      this.globalData['update'] = 0;
      this.$refs.smallModal.open();
    },
    update(){
      this.globalData['update'] = 1;
      this.$refs.smallModal.open();
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/manual-forms/globalSettings.vue